import React from 'react';
import {
    createBrowserRouter,
} from "react-router-dom";
import ConfusedListPage, {
    loader as confusedListLoader,
} from './confused';
import MainPage from './homepage';


const router = createBrowserRouter([
    {
        path: "/",
        element: (< MainPage />),
    },
    {
        path: "about/:owner/:repo",
        element: (<ConfusedListPage/>),
        loader: confusedListLoader,
    },
]);

export default router;